// extracted by mini-css-extract-plugin
export default {"container":"fc3vu0yFJAbqQQoVfktv","iconLink":"nMC1d4QYgBlb28_ZHkVF"};